import React from 'react';

interface SpinnerProps {
  title?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ title }) => {
  return (
    <div className="d-flex justify-content-center gap-2 align-content-center">
      <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
      {title && <div>{title}</div>}
    </div>
  );
};

export default Spinner;
